import React from "react";
import "../styles.css";

export const iconsConfig = {
  arrowRight: ({ size, color, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 42.67"
      fill={color}
      width={size}
      {...props}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M63.22,19.57,44.5.78a2.67,2.67,0,0,0-3.78,3.77L54.79,18.67H2.67a2.67,2.67,0,1,0,0,5.33H55L40.73,38.11a2.67,2.67,0,1,0,3.76,3.78L63.21,23.35a2.67,2.67,0,0,0,0-3.78Z"
          />
        </g>
      </g>
    </svg>
  ),
  hotel: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      fill={color}
      width={size}
      {...props}
    >
      <g>
        <g>
          <path
            d="M145.046,230.404H85.321c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C153.578,234.224,149.758,230.404,145.046,230.404z M136.514,315.725H93.853v-68.257
			h42.661V315.725z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M290.091,230.404h-59.725c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C298.623,234.224,294.803,230.404,290.091,230.404z M281.559,315.725h-42.66v-68.257
			h42.66V315.725z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M290.091,366.917h-59.725c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C298.623,370.738,294.803,366.917,290.091,366.917z M281.559,452.238h-42.66v-68.257
			h42.66V452.238z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M426.605,230.404H366.88c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C435.137,234.224,431.317,230.404,426.605,230.404z M418.073,315.725h-42.66v-68.257
			h42.66V315.725z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M145.046,366.917H85.321c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C153.578,370.738,149.758,366.917,145.046,366.917z M136.514,452.238H93.853v-68.257
			h42.661V452.238z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M426.605,366.917H366.88c-4.712,0-8.532,3.82-8.532,8.532v85.321c0,4.712,3.82,8.532,8.532,8.532h59.725
			c4.712,0,8.532-3.82,8.532-8.532v-85.321C435.137,370.738,431.317,366.917,426.605,366.917z M418.073,452.238h-42.66v-68.257
			h42.66V452.238z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M477.798,494.899V204.807h8.532c4.712,0,8.532-3.82,8.532-8.532v-42.66c0-4.712-3.82-8.532-8.532-8.532h-8.532v-34.128
			c0-4.712-3.82-8.532-8.532-8.532h-17.064V8.569c0-4.712-3.82-8.532-8.532-8.532H68.257c-4.712,0-8.532,3.82-8.532,8.532v93.853
			H42.661c-4.712,0-8.532,3.82-8.532,8.532v34.128h-8.532c-4.712,0-8.532,3.82-8.532,8.532v42.66c0,4.712,3.82,8.532,8.532,8.532
			h8.532v290.091H0v17.064h42.661h426.605H512v-17.064H477.798z M76.789,17.101h358.348v85.321H76.789V17.101z M51.193,119.486
			h17.064h375.412h17.064v25.596H51.193V119.486z M460.733,494.899H51.193V204.807h409.541V494.899z M42.661,187.743h-8.532v-25.596
			h8.532h426.605h8.532v25.596h-8.532H42.661z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M242.858,46.292c-1.357-3.468-3.263-6.463-5.721-8.984c-2.457-2.521-5.414-4.499-8.869-5.932
			c-3.456-1.433-7.282-2.15-11.48-2.15c-4.198,0-8.031,0.71-11.499,2.131c-3.468,1.421-6.437,3.398-8.907,5.932
			c-2.47,2.534-4.383,5.535-5.74,9.004c-1.357,3.468-2.035,7.237-2.035,11.307c0,4.07,0.678,7.839,2.035,11.307
			c1.357,3.468,3.27,6.469,5.74,9.004c2.47,2.534,5.439,4.511,8.907,5.932c3.468,1.421,7.301,2.131,11.499,2.131
			c4.198,0,8.024-0.71,11.48-2.131c3.456-1.42,6.412-3.398,8.869-5.932c2.457-2.534,4.364-5.535,5.721-9.004
			c1.357-3.468,2.035-7.237,2.035-11.307C244.893,53.529,244.214,49.76,242.858,46.292z M233.086,65.796
			c-0.806,2.419-1.965,4.467-3.475,6.143c-1.51,1.677-3.347,2.963-5.51,3.859c-2.163,0.896-4.601,1.344-7.314,1.344
			c-2.713,0-5.158-0.448-7.333-1.344c-2.176-0.896-4.025-2.182-5.548-3.859c-1.523-1.677-2.694-3.724-3.513-6.143
			c-0.819-2.419-1.229-5.151-1.229-8.197s0.41-5.778,1.229-8.197c0.819-2.419,1.99-4.473,3.513-6.162
			c1.523-1.689,3.372-2.982,5.548-3.878c2.176-0.896,4.62-1.344,7.333-1.344c2.713,0,5.151,0.448,7.314,1.344
			c2.163,0.896,3.999,2.189,5.51,3.878c1.51,1.689,2.668,3.743,3.475,6.162c0.806,2.419,1.209,5.151,1.209,8.197
			S233.893,63.377,233.086,65.796z"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="170.023,29.84 170.023,53.721 143.992,53.721 143.992,29.84 133.587,29.84 133.587,85.358 143.992,85.358 
			143.992,61.093 170.023,61.093 170.023,85.358 180.428,85.358 180.428,29.84 		"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon points="350.017,76.834 350.017,29.84 339.688,29.84 339.688,85.358 372.247,85.358 372.247,76.834 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="245.353,29.84 245.353,38.325 262.132,38.325 262.132,85.358 272.46,85.358 272.46,38.325 289.161,38.325 
			289.161,29.84 		"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="330.743,38.056 330.743,29.84 295.727,29.84 295.727,85.358 330.743,85.358 330.743,77.103 306.132,77.103 
			306.132,61.4 325.521,61.4 325.521,53.452 306.132,53.452 306.132,38.056 		"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  house: ({ size, color, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill={color}
      width={size}
      {...props}
    >
      <path
        id="House"
        d="M24.82,10,21,6.84V1.5a.49.49,0,0,0-.5-.5h-3a.49.49,0,0,0-.5.5V3.56L12.82.12a.51.51,0,0,0-.64,0L.18,10a.5.5,0,0,0-.08.69l1.48,1.91a.5.5,0,0,0,.34.2.54.54,0,0,0,.37-.11L12.5,4.3l10.21,8.37a.51.51,0,0,0,.32.11h0a.5.5,0,0,0,.34-.2l1.48-1.91A.5.5,0,0,0,24.82,10ZM12.5,5.6,3,13.37V23.75A1.27,1.27,0,0,0,4.29,25H20.71A1.27,1.27,0,0,0,22,23.75V13.37ZM12,24H7V16.5a.49.49,0,0,1,.5-.5h4a.49.49,0,0,1,.5.5Zm7-4.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-5a.49.49,0,0,1,.5-.5h3a.49.49,0,0,1,.5.5Z"
        fill={color}
      />
    </svg>
  ),
  car: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      fill={color}
      width={size}
      {...props}
    >
      <circle className="st0" cx="7" cy="23" r="3" />
      <circle className="st0" cx="23" cy="23" r="3" />
      <line className="st0" x1="28" y1="19" x2="30" y2="19" />
      <line className="st0" x1="4" y1="16" x2="24" y2="16" />
      <line className="st0" x1="13" y1="10" x2="10" y2="16" />
      <path
        className="st0"
        d="M26,23h4c0.6,0,1-0.4,1-1v-2c0-2.2-1.8-4-4-4h-3l-3.8-4.6c-0.8-0.9-1.9-1.4-3.1-1.4H9.5c-1.5,0-2.9,0.9-3.6,2.2
	L4,16H3c-1.1,0-2,0.9-2,2v4c0,0.6,0.4,1,1,1h2"
      />
      <line className="st0" x1="10" y1="23" x2="20" y2="23" />
    </svg>
  ),
  cat: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512.002 512.002"
      fill={color}
      width={size}
      {...props}
    >
      <g>
        <path
          d="M107.925,333.592c-3.481,3.872-4.604,9.133-3.004,14.075c10.101,31.202,29.68,58.063,56.619,77.682
		c27.461,19.999,60.125,30.569,94.461,30.569s67-10.571,94.461-30.569c26.939-19.619,46.518-46.48,56.62-77.683
		c1.599-4.941,0.476-10.203-3.005-14.075c-3.515-3.91-8.919-5.664-14.106-4.575c-42.708,8.956-87.782,13.497-133.97,13.497
		s-91.262-4.541-133.969-13.497C116.844,327.929,111.439,329.682,107.925,333.592z M392.565,343.801
		c-9.072,27.464-27.135,52.093-50.932,69.423c-24.879,18.118-54.49,27.694-85.631,27.694s-60.752-9.577-85.631-27.694
		c-23.797-17.331-41.861-41.961-50.933-69.425c13.416,2.802,27.059,5.176,40.887,7.123v33.053c0,6.298,3.76,11.925,9.579,14.335
		c5.819,2.412,12.456,1.09,16.909-3.363l10.519-10.519c0.095-0.095,0.206-0.134,0.346-0.124c19.412,1.643,39.036,2.475,58.326,2.475
		c19.222,0,38.843-0.835,58.317-2.484c0.136-0.014,0.25,0.029,0.345,0.124l10.527,10.527c2.976,2.976,6.926,4.552,10.956,4.552
		c2.001,0,4.022-0.389,5.953-1.189c5.819-2.41,9.579-8.037,9.579-14.335v-33.053C365.504,348.975,379.145,346.602,392.565,343.801z
		 M336.678,352.85v31.125c0,0.177,0,0.345-0.319,0.477c-0.319,0.131-0.437,0.013-0.562-0.112l-10.527-10.527
		c-3.222-3.222-7.68-4.845-12.218-4.464c-19.055,1.612-38.25,2.43-57.051,2.43c-18.87,0-38.068-0.815-57.061-2.421
		c-4.545-0.387-8.996,1.243-12.217,4.464l-10.519,10.519c-0.125,0.125-0.244,0.243-0.562,0.112c-0.319-0.132-0.319-0.3-0.319-0.477
		V352.85c26.355,3.094,53.327,4.664,80.677,4.664C283.349,357.514,310.319,355.944,336.678,352.85z"
        />
        <path
          d="M256.001,323.155c4.619,0,8.963-2.035,11.92-5.583l22.966-27.559c3.896-4.675,4.713-11.003,2.131-16.514
		c-2.581-5.511-7.965-8.935-14.051-8.935h-45.932c-6.086,0-11.47,3.424-14.051,8.935c-2.582,5.511-1.765,11.839,2.131,16.514
		l22.966,27.559C247.038,321.12,251.382,323.155,256.001,323.155z M232.568,279.861c0.139-0.297,0.313-0.297,0.467-0.297h45.932
		c0.154,0,0.328,0,0.467,0.297c0.139,0.297,0.028,0.431-0.071,0.549l-22.966,27.559c-0.042,0.051-0.155,0.186-0.396,0.186
		s-0.354-0.135-0.396-0.186l-22.966-27.559C232.54,280.292,232.429,280.158,232.568,279.861z"
        />
        <path
          d="M317.96,236.682c6.759-8.409,16.315-13.231,26.219-13.231s19.46,4.822,26.218,13.231c1.481,1.843,3.656,2.802,5.851,2.802
		c1.648,0,3.309-0.542,4.694-1.655c3.229-2.595,3.742-7.316,1.147-10.544c-9.62-11.969-23.438-18.833-37.91-18.833
		s-28.29,6.865-37.911,18.833c-2.595,3.229-2.082,7.949,1.147,10.544C310.644,240.423,315.364,239.91,317.96,236.682z"
        />
        <path
          d="M204.558,237.828c3.229-2.595,3.742-7.316,1.147-10.544c-9.621-11.969-23.438-18.833-37.91-18.833
		s-28.29,6.865-37.91,18.833c-2.595,3.229-2.082,7.949,1.147,10.544c3.228,2.594,7.95,2.081,10.544-1.147
		c6.759-8.409,16.315-13.231,26.219-13.231s19.46,4.822,26.219,13.231c1.482,1.843,3.656,2.802,5.851,2.802
		C201.513,239.483,203.173,238.942,204.558,237.828z"
        />
        <path
          d="M505.671,320.768l-20.767-3.279c1.579-9.749,2.56-19.644,2.89-29.644c0.091-2.766,0.117-5.526,0.111-8.282h16.596
		c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-17.106c-1.884-28.357-8.909-55.9-20.656-81.407L495.84,27.949
		c1.795-9.572-2.17-18.805-10.348-24.095c-8.177-5.289-18.224-5.121-26.22,0.441l-98.776,68.713
		c-34.412-17.399-72.879-26.023-112.261-24.721c-34.023,1.121-66.874,9.616-96.604,24.604L53.023,4.295
		c-7.997-5.562-18.043-5.73-26.22-0.441C18.625,9.144,14.66,18.377,16.455,27.95l29.001,154.674
		c-11.841,25.576-18.953,53.287-20.848,81.94H7.501c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16.594
		c-0.027,12.795,0.99,25.472,3.013,37.924l-20.778,3.281c-4.091,0.646-6.884,4.486-6.238,8.578c0.583,3.695,3.772,6.331,7.399,6.331
		c0.389,0,0.783-0.03,1.179-0.093l21.317-3.366c8.417,36.61,25.673,70.816,50.749,99.705c1.483,1.708,3.569,2.584,5.667,2.583
		c1.742,0,3.494-0.604,4.913-1.836c3.128-2.715,3.462-7.452,0.748-10.581c-23.214-26.744-39.255-58.366-47.212-92.219
		l116.125-18.336c4.091-0.646,6.884-4.486,6.238-8.578c-0.646-4.091-4.483-6.885-8.578-6.238L41.927,315.148
		c-1.903-11.683-2.86-23.578-2.832-35.584h144.761c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5H39.642
		c3.683-52.085,25.842-100.784,62.95-137.892c39.061-39.061,90.96-61.574,146.137-63.393
		c54.897-1.805,107.923,16.964,149.282,52.864c3.128,2.714,7.864,2.38,10.581-0.748c2.715-3.128,2.38-7.865-0.748-10.581
		c-10.27-8.915-21.22-16.829-32.703-23.722l92.697-64.484c4.36-3.033,8.378-0.889,9.506-0.16c1.128,0.729,4.731,3.515,3.752,8.736
		l-25.611,136.59c-7.009-11.788-15.09-23.02-24.221-33.539c-2.716-3.127-7.452-3.463-10.581-0.748
		c-3.128,2.715-3.462,7.452-0.748,10.581c30.903,35.602,49.102,79.845,52.418,126.495h-144.21c-4.142,0-7.5,3.358-7.5,7.5
		s3.358,7.5,7.5,7.5h144.759c0.006,2.592-0.018,5.187-0.104,7.788c-0.309,9.378-1.23,18.657-2.715,27.798l-116.722-18.43
		c-4.09-0.641-7.932,2.147-8.578,6.238c-0.646,4.092,2.147,7.932,6.238,8.578l116.146,18.339
		c-9.135,38.966-28.935,74.787-57.761,103.613c-39.061,39.061-90.959,61.574-146.136,63.393
		c-54.922,1.805-107.925-16.964-149.283-52.864c-3.129-2.715-7.865-2.381-10.581,0.748c-2.715,3.128-2.38,7.865,0.748,10.581
		C146.433,492.04,200.086,512,256.01,512c2.578,0,5.17-0.042,7.756-0.128c58.996-1.944,114.486-26.015,156.249-67.778
		c31.089-31.089,52.364-69.787,62.015-111.872l21.3,3.363c0.396,0.063,0.79,0.093,1.179,0.093c3.626,0,6.815-2.636,7.399-6.331
		C512.555,325.255,509.762,321.414,505.671,320.768z M91.986,116.065c-13.721,13.721-25.519,28.932-35.263,45.254L31.198,25.185
		c-0.979-5.221,2.624-8.007,3.751-8.736c1.128-0.729,5.146-2.873,9.507,0.16l92.512,64.356
		C120.749,90.678,105.631,102.42,91.986,116.065z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  dino: ({ size, color, ...props }) => (
    <svg
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={size}
      {...props}
    >
      <g>
        <path d="m92.969 35.292a2.136 2.136 0 1 0 -2.136-2.136 2.139 2.139 0 0 0 2.136 2.136z" />
        <path d="m110.018 101.31h-29.469a10.157 10.157 0 0 0 -6.79-6.891 12.665 12.665 0 0 1 -2.451-6.255 20.352 20.352 0 0 0 9.57-12.2c2-.492 5.989-1.85 7.927-5.12a3.834 3.834 0 0 1 .974 1.068 1.752 1.752 0 0 0 2.412.516 3.3 3.3 0 0 1 3.714.209 1.749 1.749 0 0 0 2.807-.977 7.71 7.71 0 0 0 -3.81-8.526 19.364 19.364 0 0 0 2.474-9.428c3.815-.828 11.991-3.114 12.966-7.662a25.774 25.774 0 0 0 .875-5.84 1.752 1.752 0 0 0 -2.247-1.426 47.466 47.466 0 0 1 -9.37 1.712q.355-.3.723-.64c3.389-3.138 6.045-4.186 9.465-3.745a1.749 1.749 0 0 0 1.976-1.735c0-.33-.067-8.106-5.86-10.44-3.693-1.489-5.613-.424-7.155.432a4.636 4.636 0 0 1 -2.282.792c-.311.007-.68 0-1.09 0-4.072-.04-13.592-.129-15.109 9.66-.134.864-.251 1.687-.364 2.471-1.067 7.459-1.467 10.251-9.961 12.176-11.005 2.495-20.812 6.257-29.384 27.123a8.326 8.326 0 0 1 -7.632 5.6 10.451 10.451 0 0 1 -9.466-5.238c-1.374-2.736-.824-5.769 1.592-8.773a1.75 1.75 0 0 0 -2.574-2.361c-.26.25-6.379 6.2-6 13.636.21 4.181 2.395 7.923 6.493 11.122a19.8 19.8 0 0 0 12.48 4.38c6.52 0 12.806-2.985 17.7-6.2a7.688 7.688 0 0 1 -.79 3.483 1.751 1.751 0 0 0 .026 1.578 19.187 19.187 0 0 1 1.957 7.5h-36.363a1.75 1.75 0 0 0 0 3.5h92.036a1.75 1.75 0 0 0 0-3.5zm-84.892-13.5c-3.255-2.541-4.988-5.408-5.15-8.521a9.806 9.806 0 0 1 .036-1.487c.107.258.217.5.326.714a13.917 13.917 0 0 0 12.725 7.164 11.832 11.832 0 0 0 10.737-7.767c7.948-19.344 16.529-22.684 26.92-25.04 10.844-2.457 11.564-7.484 12.653-15.093.11-.771.226-1.581.358-2.431.972-6.271 6.5-6.749 11.617-6.7.45 0 .853.007 1.2 0a7.893 7.893 0 0 0 3.908-1.23c1.248-.693 2-1.112 4.148-.247 2.272.915 3.137 3.525 3.467 5.335-3.535.075-6.664 1.573-10.117 4.77-2.994 2.773-4.814 2.68-4.764 2.69a1.75 1.75 0 0 0 -.8 3.4c4.858 1.422 11.445.271 15.032-.571-.118.65-.279 1.472-.5 2.507-.464 2.165-7.1 4.443-11.712 5.255a1.751 1.751 0 0 0 -1.43 1.96c.542 3.973-1.213 7.666-2.217 9.4a15.872 15.872 0 0 0 -5.053-.831 1.75 1.75 0 1 0 .317 3.485 17.553 17.553 0 0 1 4.91 1.076c.017.006.035 0 .052.009s.05.024.078.031a4.293 4.293 0 0 1 3.327 2.848 6.883 6.883 0 0 0 -3.426.255 4.98 4.98 0 0 0 -4.2-1.738 1.752 1.752 0 0 0 -1.389 1.176c-.714 2.14-3.023 3.322-4.794 3.934a18.212 18.212 0 0 0 -2.227-9.023 1.75 1.75 0 1 0 -3.058 1.716 15.162 15.162 0 0 1 1.628 9.262 16.717 16.717 0 0 1 -8.928 11.405 1.75 1.75 0 0 0 -1.06 1.654 15.758 15.758 0 0 0 3.756 9.982 1.753 1.753 0 0 0 .811.481 6.746 6.746 0 0 1 4.5 3.67h-8.865c-.852-6.373-4.461-12.177-5.954-14.348a13.84 13.84 0 0 0 1.179-7.1 12.438 12.438 0 0 0 -4.854-13 1.75 1.75 0 0 0 -2.126 2.78 8.869 8.869 0 0 1 3.624 9.2c-2.458 2.507-20.529 20.023-34.685 8.972zm30.731 5.157a11.069 11.069 0 0 0 .53-6.512c1.106-.844 2.1-1.66 2.944-2.392a11.542 11.542 0 0 1 -.915 2.238 1.75 1.75 0 0 0 .151 1.889c.052.068 4.755 6.309 5.835 13.116h-6.565a22.279 22.279 0 0 0 -1.98-8.335z" />
      </g>
    </svg>
  ),
  duck: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      fill={color}
      width={size}
      {...props}
    >
      <path
        className="st0"
        d="M14.7,16c-1.6-1.1-2.7-2.9-2.7-5c0-3.5,3.1-6.4,6.7-6c2.6,0.3,4.8,2.4,5.2,5.1c0.4,2.7-1,5-3.1,6.2
	c2.6,0.8,4.5,3.4,4.1,6.4c-0.3,3.1-3.1,5.3-6.2,5.3L12,28c-3.3,0-6-2-7-6v-8l0.8,0.6C7.9,16.2,10.4,17,13,17h0"
      />
      <line className="st0" x1="20" y1="9" x2="20" y2="12" />
      <path className="st0" d="M23.2,14c1.8-0.1,3.5-0.9,4.6-2.4L29,10h-5" />
      <path
        className="st0"
        d="M19,22c0,1.7-1.3,3-3,3c-4,0-5-3-5-3s3.3-3,5-3S19,20.3,19,22z"
      />
    </svg>
  ),
  hat: ({ size, color, ...props }) => (
    <svg
      viewBox="0 -10.77 37.171 37.171"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={size}
      {...props}
    >
      <path
        id="Hat"
        d="M616.7,302.3s-2.7-2.6-9.6-2.1l1.6,4h-.9c-.8-2.4-2.4-6.3-3.7-7.6a3.433,3.433,0,0,0-3.1-1.5,7.441,7.441,0,0,1-2.5-.5c-7.9-1.4-8,5.7-8,5.7l-.2,7.7a2.767,2.767,0,0,1-.8-.1l.1-4.6-1.9.1s-9.7,1.3-6.5,4.5c0,0,4.5,3.6,12.8,1.5,0,0,1.2-.4,3-.9.4-.1.6-.2.7-.2a15.427,15.427,0,0,0,1.7-.5c4-1,8.8-1.8,8.9-1.8a29.336,29.336,0,0,1,4.1-.3C612.5,305.7,620.5,305.9,616.7,302.3Z"
        transform="translate(-580.552 -294.417)"
      />
    </svg>
  ),
  penguin: ({ size, color, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill={color}
      width={size}
      {...props}
    >
      <path d="M104,469.127V472a24.028,24.028,0,0,0,24,24H376a8,8,0,0,0,8-8,40.045,40.045,0,0,0-40-40H319.442a620.151,620.151,0,0,0,19.427-77.559c7.655-41.81,10.683-82.994,9-122.407-2.077-48.611-11.366-94.647-27.614-136.876a73.969,73.969,0,0,1,11.338-26.626C344.608,65.6,364.933,56,392,56a8,8,0,0,0,5.657-13.657,71.962,71.962,0,0,0-24.966-14.877c-13.527-4.831-34.7-7.955-60.2,3.453C304.246,26.133,284.387,16,264,16c-16.216,0-32.984,0-50.239,14.955-17.643,15.29-34.059,44.334-53.228,94.173-16.96,44.1-24.877,105.334-23.532,182.012.845,48.143,5.292,87.574,6.667,98.76l-35.2,49.277A23.863,23.863,0,0,0,104,469.127ZM344,464a24.042,24.042,0,0,1,22.629,16h-58.6c1.687-4.246,3.734-9.612,6-16ZM367.658,42.6A82.076,82.076,0,0,0,335.22,57.624L324.486,43.313C342.272,36.84,357.023,38.75,367.658,42.6Zm-143.419.448C236.984,32,248.316,32,264,32c18.538,0,37.782,11.085,42.481,13.975L323.564,68.75a81.336,81.336,0,0,0-5.156,6.718,88.252,88.252,0,0,0-14.346,35.54A8.043,8.043,0,0,0,304,112H276.526c-17.9-28.388-45.348-42.438-68.582-49.393C213.46,54.175,218.859,47.708,224.239,43.045Zm-24.718,33.8c22.041,5.94,49.405,18.892,65.533,47.123A8,8,0,0,0,272,128h37.371c13.084,37.463,20.657,77.9,22.5,120.44a534.689,534.689,0,0,1-8.658,118.67C312.842,424,296.411,466.374,290.734,480H230.989c-3.462-33.309,8.78-61.9,13.81-72h9.441a24.112,24.112,0,0,0,21.522-13.376c26.028-53.043,23.238-93.5,16.315-118.1-5.883-20.9-15.618-34.242-20.077-39.566V169.47a39.8,39.8,0,0,0-18.7-33.86c-17.96-11.307-43.435-26.834-63.554-39.016Q194.731,85.7,199.521,76.845ZM120,469.127a7.95,7.95,0,0,1,1.49-4.649l37.02-51.828a8.007,8.007,0,0,0,1.417-5.731A954.829,954.829,0,0,1,153,306.86c-1.291-73.561,6.479-134.416,22.468-175.988q3.984-10.359,7.814-19.489c19.757,11.969,44.172,26.86,61.5,37.767A23.883,23.883,0,0,1,256,169.47V240a8,8,0,0,0,2.343,5.657c.488.488,48.242,49.83,3.055,141.918A8.007,8.007,0,0,1,254.24,392h-4.675c12.284-76.38-17.972-115.315-19.318-117a8,8,0,0,0-12.518,9.965c.294.375,29.067,38.178,14.667,112.214-3.933,7.051-21.336,40.983-17.489,82.819H128a8.009,8.009,0,0,1-8-8Z" />
      <circle cx="272" cy="64" r="8" />
    </svg>
  ),
  ship: ({ size, color, ...props }) => (
    <svg
      viewBox="0 0 74 74"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={size}
      {...props}
    >
      <path d="m62.784 58.1a.984.984 0 0 1 -.309-.05 1 1 0 0 1 -.642-1.26l7.287-22.421a1.247 1.247 0 0 0 -.163-1.149 1.23 1.23 0 0 0 -1.014-.52h-18.043a1.116 1.116 0 0 0 -.977.565l-2.209 3.891a3.141 3.141 0 0 1 -2.714 1.585h-34.114a1.248 1.248 0 0 0 -1.212 1.538l3.646 16.6a1 1 0 0 1 -1.953.429l-3.643-16.585a3.248 3.248 0 0 1 3.162-3.982h34.114a1.135 1.135 0 0 0 .982-.574l2.2-3.882a3.113 3.113 0 0 1 2.718-1.585h18.043a3.212 3.212 0 0 1 2.64 1.355 3.264 3.264 0 0 1 .435 2.945l-7.283 22.405a1 1 0 0 1 -.951.695z" />
      <path d="m61.726 65.57a10.3 10.3 0 0 1 -4.524-.939 9.38 9.38 0 0 0 -7.508 0 11.36 11.36 0 0 1 -9.045 0 8.273 8.273 0 0 0 -3.753-.784 8.273 8.273 0 0 0 -3.753.784 10.3 10.3 0 0 1 -4.521.939 10.3 10.3 0 0 1 -4.521-.939 8.264 8.264 0 0 0 -3.751-.784 8.264 8.264 0 0 0 -3.751.784 10.29 10.29 0 0 1 -4.52.939 10.3 10.3 0 0 1 -4.521-.939 8.264 8.264 0 0 0 -3.751-.784 1 1 0 1 1 0-2 10.3 10.3 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.268 8.268 0 0 0 3.751-.785 10.293 10.293 0 0 1 4.52-.938 10.3 10.3 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.27 8.27 0 0 0 3.752-.785 10.3 10.3 0 0 1 4.522-.938 10.3 10.3 0 0 1 4.522.938 8.276 8.276 0 0 0 3.754.785 8.271 8.271 0 0 0 3.753-.785 11.371 11.371 0 0 1 9.045 0 9.376 9.376 0 0 0 7.511 0 10.313 10.313 0 0 1 4.524-.938 1 1 0 0 1 0 2 8.283 8.283 0 0 0 -3.755.784 10.307 10.307 0 0 1 -4.524.939z" />
      <path d="m61.726 58.139a10.306 10.306 0 0 1 -4.526-.939 9.369 9.369 0 0 0 -7.508 0 11.371 11.371 0 0 1 -9.045 0 8.271 8.271 0 0 0 -3.753-.785 8.271 8.271 0 0 0 -3.753.785 10.3 10.3 0 0 1 -4.521.938 10.3 10.3 0 0 1 -4.52-.938 8.262 8.262 0 0 0 -3.751-.785 8.262 8.262 0 0 0 -3.749.785 10.293 10.293 0 0 1 -4.52.938 10.3 10.3 0 0 1 -4.522-.938 8.262 8.262 0 0 0 -3.751-.785 1 1 0 0 1 0-2 10.316 10.316 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.268 8.268 0 0 0 3.751-.785 10.307 10.307 0 0 1 4.52-.938 10.316 10.316 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.27 8.27 0 0 0 3.752-.785 10.314 10.314 0 0 1 4.522-.938 10.314 10.314 0 0 1 4.522.938 8.276 8.276 0 0 0 3.754.785 8.271 8.271 0 0 0 3.753-.785 11.371 11.371 0 0 1 9.045 0 9.376 9.376 0 0 0 7.511 0 10.328 10.328 0 0 1 4.524-.938 1 1 0 0 1 0 2 8.281 8.281 0 0 0 -3.755.785 10.31 10.31 0 0 1 -4.524.939z" />
      <path d="m61.726 73a10.321 10.321 0 0 1 -4.524-.938 9.369 9.369 0 0 0 -7.508 0 11.371 11.371 0 0 1 -9.045 0 8.271 8.271 0 0 0 -3.753-.785 8.271 8.271 0 0 0 -3.753.785 10.312 10.312 0 0 1 -4.521.938 10.312 10.312 0 0 1 -4.521-.938 8.262 8.262 0 0 0 -3.751-.785 8.262 8.262 0 0 0 -3.751.785 10.307 10.307 0 0 1 -4.52.938 10.312 10.312 0 0 1 -4.521-.938 8.262 8.262 0 0 0 -3.751-.785 1 1 0 0 1 0-2 10.3 10.3 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.268 8.268 0 0 0 3.751-.785 10.293 10.293 0 0 1 4.52-.938 10.3 10.3 0 0 1 4.521.938 8.262 8.262 0 0 0 3.751.785 8.27 8.27 0 0 0 3.752-.785 10.3 10.3 0 0 1 4.522-.938 10.3 10.3 0 0 1 4.522.938 8.276 8.276 0 0 0 3.754.785 8.271 8.271 0 0 0 3.753-.785 11.371 11.371 0 0 1 9.045 0 9.376 9.376 0 0 0 7.511 0 10.313 10.313 0 0 1 4.524-.938 1 1 0 0 1 0 2 8.281 8.281 0 0 0 -3.755.785 10.324 10.324 0 0 1 -4.524.938z" />
      <path d="m34.048 38.742h-16.8a1 1 0 0 1 -1-1v-10.463a1 1 0 0 1 1-1h16.8a1 1 0 0 1 1 1v10.463a1 1 0 0 1 -1 1zm-15.8-2h14.8v-8.463h-14.8z" />
      <path d="m35.771 28.279h-20.245a1 1 0 0 1 -1-1v-3.733a1 1 0 0 1 1-1h20.245a1 1 0 0 1 1 1v3.733a1 1 0 0 1 -1 1zm-19.245-2h18.245v-1.733h-18.245z" />
      <path d="m27.725 24.546h-4.283a1 1 0 0 1 -1-1v-7.9a1 1 0 0 1 1-1h4.283a1 1 0 0 1 1 1v7.9a1 1 0 0 1 -1 1zm-3.283-2h2.283v-5.9h-2.283z" />
      <path d="m23.473 38.742h-3.187a1 1 0 0 1 -1-1v-4.791a1 1 0 0 1 1-1h3.187a1 1 0 0 1 1 1v4.791a1 1 0 0 1 -1 1zm-2.187-2h1.187v-2.791h-1.187z" />
      <path d="m31.011 38.742h-3.187a1 1 0 0 1 -1-1v-4.791a1 1 0 0 1 1-1h3.187a1 1 0 0 1 1 1v4.791a1 1 0 0 1 -1 1zm-2.187-2h1.187v-2.791h-1.187z" />
      <path d="m15.582 15.456a4.473 4.473 0 0 1 -.733-.06 4.12 4.12 0 0 1 -2.925-1.935 3.865 3.865 0 0 1 -1.813.133 3.755 3.755 0 0 1 -2.269-1.252 3.106 3.106 0 0 1 -.721-1.6c-.117-.009-.233-.023-.349-.042a3.5 3.5 0 0 1 -3.1-3.825 3.1 3.1 0 0 1 1.5-2.161 3.8 3.8 0 0 1 1.692-.53 3.536 3.536 0 0 1 3.989-2.134 3.9 3.9 0 0 1 2.205 1.14 4.242 4.242 0 0 1 2.681-.426 4.115 4.115 0 0 1 2.948 1.991 3.811 3.811 0 0 1 .783.047 3.281 3.281 0 0 1 2.9 3.6c-.016.1-.037.193-.062.287a3.169 3.169 0 0 1 1.322 3.02 3.405 3.405 0 0 1 -4.048 2.582 4.02 4.02 0 0 1 -.912-.261 3.886 3.886 0 0 1 -3.088 1.426zm-3.1-4.434a1 1 0 0 1 .995.9 1.909 1.909 0 0 0 1.693 1.5 1.827 1.827 0 0 0 2.145-1.064 1 1 0 0 1 1.645-.481 1.822 1.822 0 0 0 .947.441 1.452 1.452 0 0 0 1.751-.93 1.341 1.341 0 0 0 -1.011-1.344 1 1 0 0 1 -.424-1.585.779.779 0 0 0 .175-.377c.095-.58-.478-1.177-1.25-1.3a1.731 1.731 0 0 0 -.8.05 1 1 0 0 1 -1.278-.741 1.962 1.962 0 0 0 -1.658-1.346 2.065 2.065 0 0 0 -1.852.556 1 1 0 0 1 -1.676-.301 1.722 1.722 0 0 0 -1.352-.97 1.5 1.5 0 0 0 -1.815.964.866.866 0 0 0 -.012.183 1 1 0 0 1 -1.159 1.035l-.04-.006a1.917 1.917 0 0 0 -1.3.223 1.128 1.128 0 0 0 -.563.772c-.111.683.552 1.383 1.448 1.529a2.069 2.069 0 0 0 .881-.042 1 1 0 0 1 1.189 1.352.863.863 0 0 0 -.056.2 1.032 1.032 0 0 0 .262.813 1.785 1.785 0 0 0 1.066.573 1.69 1.69 0 0 0 1.386-.347 1 1 0 0 1 .664-.257z" />
    </svg>
  ),

  bank: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      fill={color}
      width={size}
      {...props}
    >
      <polygon className="st0" points="16,3 3,10 3,13 29,13 29,10 " />
      <rect x="14" y="13" className="st0" width="4" height="10" />
      <rect x="23" y="13" className="st0" width="4" height="10" />
      <rect x="5" y="13" className="st0" width="4" height="10" />
      <rect x="3" y="23" className="st0" width="26" height="3" />
      <rect x="1" y="26" className="st0" width="30" height="3" />
    </svg>
  ),
  dice: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 423.757 423.757"
      fill={color}
      width={size}
      {...props}
    >
      <g>
        <g>
          <path
            d="M189.294,385.219l112.522,38.538l98.514-98.509l-113.3-37.765L189.294,385.219z M239.962,379.203
			c-5.96,5.96-15.672,8.54-21.699,5.76c-6.021-2.78-6.077-9.861-0.113-15.821c5.96-5.96,15.672-8.54,21.699-5.76
			C245.875,366.162,245.921,373.243,239.962,379.203z M276.298,391.931c-5.96,5.96-15.672,8.54-21.699,5.76
			c-6.021-2.78-6.077-9.861-0.113-15.821c5.965-5.96,15.672-8.54,21.699-5.76C282.207,378.89,282.258,385.971,276.298,391.931z
			 M349.56,334.94c5.96-5.96,15.672-8.54,21.699-5.76c6.021,2.78,6.077,9.861,0.118,15.821s-15.672,8.54-21.699,5.76
			S343.601,340.9,349.56,334.94z M313.331,323.031c5.96-5.96,15.672-8.54,21.699-5.76c6.021,2.78,6.077,9.861,0.113,15.821
			c-5.96,5.96-15.672,8.54-21.699,5.76C307.423,336.072,307.372,328.991,313.331,323.031z M312.415,388.019
			c6.021,2.78,6.077,9.861,0.113,15.821c-5.96,5.96-15.672,8.54-21.699,5.76s-6.077-9.861-0.118-15.821
			C296.676,387.825,306.388,385.244,312.415,388.019z M298.693,304.538c6.021,2.78,6.077,9.861,0.113,15.821
			c-5.96,5.96-15.672,8.54-21.699,5.76c-6.021-2.78-6.077-9.861-0.113-15.821C282.954,304.338,292.667,301.763,298.693,304.538z"
          />
          <path
            d="M402.158,311.634l-37.202-111.611l-111.611-37.207l37.202,111.606L402.158,311.634z M319.281,224.118
			c4.168-4.168,12.544-2.555,18.708,3.61s7.782,14.541,3.61,18.708c-4.168,4.168-12.544,2.555-18.708-3.61
			C316.726,236.662,315.108,228.285,319.281,224.118z"
          />
          <path
            d="M135.171,0L29.939,52.613l105.231,52.613l105.226-52.613L135.171,0z M135.171,63.288c-8.714,0-15.785-4.782-15.785-10.675
			c0-5.898,7.066-10.675,15.785-10.675s15.785,4.782,15.785,10.675C150.95,58.511,143.885,63.288,135.171,63.288z"
          />
          <path
            d="M162.22,201.728c5.028-1.853,9.231,1.08,10.685,6.702l63.022-63.022l12.805,4.27V63.529l-106.819,53.412v122.481
			l10.798-10.798c-1.101-1.951-1.761-4.48-1.761-7.475C150.95,212.716,155.999,204.022,162.22,201.728z M230.956,86.866
			c6.226-2.294,11.269,2.678,11.269,11.105c0,8.427-5.043,17.121-11.269,19.415c-6.226,2.294-11.269-2.678-11.269-11.105
			C219.686,97.853,224.73,89.16,230.956,86.866z M198.843,142.003c6.226-2.294,11.269,2.678,11.269,11.105
			c0,8.427-5.043,17.121-11.269,19.415c-6.226,2.294-11.269-2.678-11.269-11.105C187.574,152.991,192.622,144.297,198.843,142.003z
			 M150.95,140.175c0-8.427,5.043-17.121,11.269-19.415c6.226-2.294,11.269,2.678,11.269,11.105c0,8.428-5.043,17.121-11.269,19.415
			C155.994,153.574,150.95,148.603,150.95,140.175z"
          />
          <path
            d="M21.599,202.839l105.313,51.579l1.51-1.51V116.941L21.599,63.529V202.839z M107.855,201.728
			c6.226,2.294,11.269,10.988,11.269,19.415s-5.043,13.399-11.269,11.105c-6.226-2.294-11.269-10.988-11.269-19.415
			C96.586,204.406,101.635,199.434,107.855,201.728z M75.011,140.298c6.226,2.294,11.269,10.987,11.269,19.415
			c0,8.427-5.043,13.399-11.269,11.105c-6.226-2.294-11.269-10.988-11.269-19.415C63.741,142.976,68.79,138.004,75.011,140.298z
			 M41.208,86.866c6.226,2.294,11.269,10.987,11.269,19.415c0,8.427-5.043,13.399-11.269,11.105
			c-6.226-2.294-11.269-10.987-11.269-19.415C29.939,89.544,34.982,84.572,41.208,86.866z"
          />
          <path
            d="M239.726,164.639l-98.514,98.504l38.543,112.533l97.736-97.746L239.726,164.639z M197.655,338.565
			c-5.96,5.96-13.046,5.909-15.821-0.118c-2.775-6.026-0.2-15.739,5.76-21.699c5.96-5.96,13.046-5.909,15.821,0.113
			C206.19,322.883,203.615,332.605,197.655,338.565z M230.525,221.773c-5.96,5.96-13.046,5.908-15.821-0.113
			c-2.78-6.021-0.2-15.739,5.76-21.699c5.96-5.96,13.046-5.908,15.821,0.113C239.066,206.1,236.485,215.813,230.525,221.773z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  player: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 122.88 116.22"
      fill={"olive"}
      width={size}
      {...props}
    >
      <g>
        <path d="M41.68,75.91c6.32,13.18,25.49,13.65,31.54,0.08c-1.65-1.67-2.88-3.46-4.09-5.24c-0.2-0.29-0.4-0.58-0.6-0.88 c-2.92,2.32-6.47,3.8-11.09,3.79c-4.98-0.01-8.74-1.92-11.81-4.73c-0.18-0.17-0.37-0.34-0.55-0.51c-0.44,1.22-1,2.69-1.6,4.06 C42.9,73.78,42.28,75.02,41.68,75.91L41.68,75.91L41.68,75.91z M84.73,93.6l4.54-4.76l6.55,6.3l10.2-13.59l5.07,4.09 c-2.39,2.96-10.91,14.65-12.77,16.17c-1.53,1.25-3.73,1.25-5.15-0.12L84.73,93.6L84.73,93.6z M97.97,66.4 c6.88,0,13.1,2.79,17.61,7.3c4.51,4.51,7.29,10.73,7.29,17.61c0,6.88-2.79,13.1-7.29,17.61c-4.51,4.51-10.73,7.3-17.61,7.3 c-6.88,0-13.1-2.79-17.61-7.3c-4.51-4.51-7.3-10.73-7.3-17.61c0-4.98,1.46-9.62,3.98-13.51c-0.72-0.31-1.43-0.67-2.2-1.1 c-3.06,14.18-27.23,17.6-34.69,0.81c-5.27,2.65-10.62,4.66-16.74,5.61l3.56,25.69H5.76c-10.52-0.8-4.03-16-0.86-20.19 c1.52-2.01,3.41-3.49,5.5-4.66c6.28-3.5,22.63-4.66,29.41-9.39c0.5-0.75,1.04-1.84,1.55-3.02c0.78-1.78,1.49-3.72,1.94-5.04 c-1.9-2.23-3.52-4.75-5.08-7.24l-5.14-8.17c-1.88-2.8-2.86-5.37-2.92-7.47c-0.03-0.99,0.14-1.89,0.5-2.68 c0.38-0.83,0.97-1.52,1.77-2.05c0.37-0.25,0.79-0.46,1.25-0.64c-0.33-4.43-0.46-10.02-0.24-14.7c0.11-1.11,0.32-2.22,0.63-3.33 c1.31-4.69,4.61-8.47,8.68-11.07c2.25-1.43,4.71-2.51,7.28-3.24c1.63-0.46-1.39-5.68,0.3-5.85C58.49-0.77,71.7,6.68,77.4,12.84 c2.85,3.09,4.64,7.18,5.03,12.6l-0.32,13.34v0c1.43,0.43,2.34,1.34,2.71,2.8c0.41,1.62-0.04,3.91-1.41,7.02l0,0 c-0.02,0.06-0.05,0.11-0.09,0.17l-5.86,9.65c-2.15,3.54-4.34,7.1-7.19,9.9c0.26,0.37,0.51,0.74,0.77,1.12 c1.16,1.7,2.33,3.4,3.83,4.92c0.05,0.05,0.09,0.1,0.13,0.16c0.89,0.63,1.96,1.2,3.15,1.72c0.68-0.89,1.42-1.74,2.21-2.53 C84.87,69.19,91.1,66.4,97.97,66.4L97.97,66.4L97.97,66.4z M36.64,40.62c-1.14,0.04-2,0.28-2.59,0.68 c-0.34,0.23-0.58,0.51-0.74,0.86c-0.18,0.38-0.26,0.84-0.24,1.38c0.04,1.56,0.86,3.61,2.45,5.96l0.02,0.03l5.14,8.17 c2.06,3.28,4.22,6.62,6.91,9.07c2.58,2.36,5.72,3.96,9.86,3.97c4.49,0.01,7.77-1.65,10.43-4.14c2.77-2.59,4.95-6.15,7.11-9.69 l5.79-9.54c1.08-2.46,1.47-4.11,1.23-5.08c-0.15-0.58-0.78-0.86-1.86-0.91c-0.23-0.01-0.47-0.01-0.7-0.01 c-0.26,0.01-0.53,0.03-0.81,0.05c-0.15,0.01-0.3,0-0.45-0.03c-0.52,0.03-1.05-0.01-1.59-0.09l1.98-8.78 c-14.71,2.32-25.72-8.61-41.27-2.19l1.12,10.34C37.79,40.73,37.19,40.71,36.64,40.62L36.64,40.62L36.64,40.62L36.64,40.62z M97.97,70.26c-5.81,0-11.08,2.36-14.89,6.17c-3.81,3.81-6.17,9.07-6.17,14.89c0,11.63,9.43,21.05,21.06,21.05 c5.81,0,11.08-2.36,14.89-6.17c3.81-3.81,6.17-9.07,6.17-14.89C119.03,79.68,109.6,70.26,97.97,70.26L97.97,70.26z" />
      </g>
    </svg>
  ),
  game: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100.75 100.75"
      fill={color}
      width={size}
      {...props}
    >
      <path
        d="M49.971,10.444c-21.891,0-39.699,17.809-39.699,39.699s17.809,39.699,39.699,39.699S89.67,72.033,89.67,50.143
	S71.862,10.444,49.971,10.444z M80.963,30.524C63.613,31.403,51.771,45.209,49.14,48.57c-2.384-0.233-9.195-1.162-16.304-4.478
	c2.083-4.974,11.274-23.454,33.734-26.665C72.46,20.429,77.435,24.971,80.963,30.524z M49.971,13.444
	c4.052,0,7.948,0.67,11.596,1.888c-20.345,5-29.103,22.011-31.408,27.398c-4.434-2.456-8.772-5.925-12.019-10.817
	C24.479,20.889,36.368,13.444,49.971,13.444z M13.272,50.143c0-5.426,1.193-10.576,3.316-15.215
	C27.069,49.196,45.679,51.322,49.3,51.602c0.902,2.189,3.177,8.354,3.682,15.889c-6.063,0.814-25.686,1.89-39.628-15.01
	C13.306,51.706,13.272,50.928,13.272,50.143z M49.17,86.822c-17.276-0.373-31.648-12.733-35.103-29.083
	c11.051,11.04,24.479,13.112,32.996,13.112c2.486,0,4.551-0.177,6.019-0.358C53.076,75.742,52.08,81.446,49.17,86.822z
	 M70.152,80.773c-5.112,3.379-11.114,5.509-17.573,5.966c7.688-16.017,0.73-33.501-0.706-36.765
	c1.836-2.226,6.615-7.511,13.491-11.511C68.786,43.342,78.956,60.454,70.152,80.773z M74.65,77.282
	c5.967-19.146-3.011-34.941-6.631-40.238c4.268-2.087,9.197-3.562,14.629-3.574c2.565,5.007,4.023,10.671,4.023,16.673
	C86.671,60.885,82.031,70.564,74.65,77.282z"
      />
    </svg>
  ),
  defeat: ({ size, color, ...props }) => (
    <svg
      enableBackground="new 0 0 32 32"
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={size}
      {...props}
    >
      <path
        clip-rule="evenodd"
        d="M16.716,31.705L16.716,31.705L16.716,31.705  l9.991-9.97c0.66-0.634,0.162-1.748-0.734-1.723h-4.976C20.998,20.008,21,20.004,21,20V1c0-0.55-0.45-1-1-1l-8,0c-0.55,0-1,0.45-1,1  v19c0,0.004,0.002,0.008,0.002,0.012H6.031c-0.892-0.024-1.376,1.082-0.742,1.715l9.999,9.977  C15.682,32.098,16.322,32.098,16.716,31.705z M8.436,22.017H13V22v-1v-0.988h-0.002C12.998,20.008,13,20.004,13,20v-1V2h6v17v1  c0,0.004,0.002,0.008,0.002,0.012H19V21v1v0.017h4.568l-7.566,7.55L8.436,22.017z"
        fill="#121313"
        fill-rule="evenodd"
        id="Arrow_Down"
      />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  win: ({ size, color, ...props }) => (
    <svg
      id="Layer_1"
      enableBackground="new 0 0 512.02 512.02"
      viewBox="0 0 512.02 512.02"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      {...props}
    >
      <g>
        <path
          d="m451.576 311.719c33.328 0 60.443-27.115 60.443-60.443v-28.87h-38.306c-11.765 0-23.143 3.437-32.891 9.791-1.088-5.996-2.452-11.92-4.107-17.747l11.556-6.65c13.982-8.072 23.983-21.106 28.162-36.702 4.179-15.595 2.034-31.884-6.038-45.866l-14.435-25.002-33.173 19.153c-10.19 5.883-18.321 14.548-23.576 24.924-4.165-4.894-8.603-9.588-13.293-14.071l5.569-9.645c8.072-13.982 10.217-30.271 6.038-45.866s-14.18-28.629-28.162-36.702l-25.002-14.435-19.153 33.173c-8.072 13.982-10.217 30.271-6.038 45.866s14.18 28.629 28.162 36.702l10.807 6.24c35.427 30.033 55.729 73.824 55.729 120.357 0 87.041-70.813 157.854-157.855 157.854-87.041 0-157.854-70.813-157.854-157.854 0-46.533 20.302-90.324 55.729-120.357l10.807-6.24c13.982-8.072 23.983-21.106 28.162-36.702 4.178-15.595 2.033-31.884-6.039-45.866l-19.152-33.174-25.002 14.436c-28.863 16.664-38.788 53.704-22.124 82.568l5.569 9.645c-4.692 4.484-9.131 9.18-13.297 14.076-5.255-10.379-13.386-19.046-23.578-24.929l-33.174-19.153-14.436 25.002c-8.072 13.982-10.217 30.271-6.038 45.866s14.18 28.629 28.18 36.712l11.544 6.643c-1.655 5.828-3.019 11.752-4.107 17.748-9.749-6.357-21.13-9.795-32.897-9.795h-38.306v28.87c0 33.329 27.115 60.443 60.464 60.443l13.345-.019c1.491 5.934 3.267 11.756 5.309 17.453-11.635-.648-23.216 2.055-33.405 7.937l-33.175 19.153 14.437 25.002c8.072 13.982 21.106 23.983 36.702 28.162 5.206 1.395 10.487 2.085 15.737 2.085 10.476 0 20.82-2.75 30.146-8.134l11.645-6.746c4.235 4.368 8.68 8.53 13.318 12.472-10.411 5.253-19.105 13.399-25.004 23.615l-19.152 33.174 25.002 14.435c9.314 5.377 19.649 8.124 30.123 8.124 5.25 0 10.536-.69 15.743-2.086 15.595-4.179 28.629-14.18 36.712-28.18l6.642-11.54c16.349 4.659 33.6 7.155 51.423 7.155 17.822 0 35.071-2.495 51.418-7.153l6.651 11.557c8.072 13.982 21.106 23.983 36.701 28.162 5.208 1.396 10.492 2.086 15.743 2.086 10.473 0 20.81-2.747 30.123-8.124l25.002-14.435-19.152-33.174c-5.898-10.214-14.59-18.359-25-23.613 4.639-3.942 9.084-8.104 13.32-12.472l11.658 6.755c9.314 5.377 19.649 8.124 30.124 8.124 5.249 0 10.535-.69 15.742-2.085 15.595-4.179 28.629-14.18 36.701-28.162l14.437-25.002-33.175-19.153c-10.188-5.882-21.765-8.584-33.398-7.938 2.042-5.696 3.817-11.518 5.309-17.452z"
          fill="#bee75e"
        />
        <path
          d="m373.5 236.239-81.126-11.883-36.371-73.485-36.371 73.484-81.127 11.883 58.648 57.299-13.767 80.828 72.617-38.072 72.617 38.072-13.768-80.828z"
          fill="#ffd321"
        />
        <path
          d="m451.576 311.719c33.328 0 60.443-27.115 60.443-60.443v-28.87h-38.306c-11.765 0-23.143 3.437-32.891 9.791-1.088-5.996-2.452-11.92-4.107-17.747l11.556-6.65c13.982-8.072 23.983-21.106 28.162-36.702 4.179-15.595 2.034-31.884-6.038-45.866l-14.435-25.002-33.173 19.153c-10.19 5.883-18.321 14.548-23.576 24.924-4.165-4.894-8.603-9.588-13.293-14.071l5.569-9.645c8.072-13.982 10.217-30.271 6.038-45.866s-14.18-28.629-28.162-36.702l-25.002-14.435-19.153 33.173c-8.072 13.982-10.217 30.271-6.038 45.866s14.18 28.629 28.162 36.702l10.807 6.24c35.427 30.033 55.729 73.824 55.729 120.357 0 87.041-70.813 157.854-157.855 157.854-.003 0-.007 0-.01 0v30h.01c17.822 0 35.071-2.495 51.418-7.153l6.651 11.557c8.072 13.982 21.106 23.983 36.701 28.162 5.208 1.396 10.492 2.086 15.743 2.086 10.473 0 20.81-2.747 30.123-8.124l25.002-14.435-19.152-33.174c-5.898-10.214-14.59-18.359-25-23.613 4.639-3.942 9.084-8.104 13.32-12.472l11.658 6.755c9.314 5.377 19.649 8.124 30.124 8.124 5.249 0 10.535-.69 15.742-2.085 15.595-4.179 28.629-14.18 36.701-28.162l14.437-25.002-33.175-19.153c-10.188-5.882-21.765-8.584-33.398-7.938 2.042-5.696 3.817-11.518 5.309-17.452z"
          fill="#5bc980"
        />
        <path
          d="m314.852 293.537 58.648-57.298-81.126-11.883-36.371-73.485v185.422l72.617 38.072z"
          fill="#ffaf00"
        />
      </g>
    </svg>
  ),
  logo: ({ size, color, ...props }) => (
    <svg
      id="Layer_5"
      enableBackground="new 0 0 64 64"
      viewBox="0 0 64 64"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      {...props}
    >
      <path d="m31 46h2v2h-2z" />
      <path d="m63 25v-2h-2c-.85 0-1.658.18-2.391.5.893-.519 1.653-1.243 2.183-2.161.802-1.388 1.015-3.005.6-4.553l-.518-1.933-1.932.519c-.826.221-1.57.617-2.215 1.139.747-.739 1.306-1.649 1.585-2.69.414-1.548.201-3.165-.6-4.553l-1-1.732-1.732 1c-.672.388-1.246.896-1.712 1.488.459-.858.703-1.822.703-2.823 0-1.603-.624-3.109-1.758-4.243l-1.414-1.414-1.414 1.414c-.639.639-1.087 1.392-1.377 2.19-1.363-2.47-3.992-4.148-7.008-4.148h-2v1c0 3.13 1.811 5.839 4.437 7.152-.402.246-.781.535-1.123.877l-1.414 1.415 1.414 1.414c.724.723 1.6 1.237 2.556 1.515l-.281.162 1 1.732c.516.893 1.251 1.599 2.112 2.116l-.348.093.518 1.932c.27 1.008.783 1.886 1.459 2.591h-.33v2c0 1.043.269 2.025.739 2.88l-.317-.085-.518 1.932c-.265.989-.271 2.005-.034 2.972l-.282-.163-1 1.731c-1.599 2.772-.724 6.297 1.926 8.021-1.129 1.358-2.422 2.601-3.861 3.711h-2.833l.499-2.493-6.856 2.285-4.463-7.806-4.462 7.808-6.856-2.285.498 2.493h-2.833c-1.439-1.11-2.732-2.353-3.861-3.711 2.65-1.725 3.525-5.249 1.926-8.021l-1-1.731-.282.163c.237-.967.231-1.984-.034-2.972l-.518-1.932-.317.085c.47-.856.739-1.838.739-2.881v-2h-.328c.676-.705 1.189-1.583 1.459-2.591l.518-1.932-.348-.093c.86-.517 1.596-1.223 2.112-2.116l1-1.732-.281-.162c.956-.279 1.832-.792 2.556-1.515l1.414-1.414-1.414-1.415c-.342-.342-.721-.631-1.123-.877 2.624-1.314 4.435-4.023 4.435-7.153v-1h-2c-3.016 0-5.645 1.678-7.008 4.149-.29-.798-.738-1.551-1.377-2.19l-1.414-1.414-1.414 1.414c-1.134 1.133-1.758 2.64-1.758 4.243 0 1.001.243 1.964.703 2.823-.466-.592-1.04-1.1-1.712-1.488l-1.732-1-1 1.732c-.801 1.388-1.014 3.004-.6 4.553.279 1.041.839 1.951 1.585 2.69-.645-.522-1.389-.918-2.215-1.139l-1.932-.519-.518 1.933c-.415 1.548-.202 3.165.6 4.553.53.918 1.29 1.642 2.183 2.161-.733-.321-1.541-.501-2.391-.501h-2v2c0 2.701 1.794 4.989 4.253 5.739-.749-.09-1.516-.039-2.266.162l-1.932.518.518 1.932c.414 1.548 1.407 2.842 2.795 3.643.88.508 1.853.772 2.841.797-.751.101-1.494.344-2.19.746l-1.732 1 1 1.731c1.11 1.923 3.131 2.999 5.206 2.999 1.018 0 2.048-.259 2.99-.803l.263-.151c.767.947 1.603 1.845 2.509 2.688h-1.255v5h-12.081l4.801 6-4.801 6h24.081v-7h12v7h24.081l-4.801-6 4.801-6h-12.081v-5h-1.255c.906-.842 1.742-1.741 2.509-2.688l.263.151c.942.544 1.973.803 2.99.803 2.075 0 4.096-1.076 5.206-2.999l1-1.731-1.732-1c-.695-.402-1.439-.645-2.19-.746.989-.025 1.961-.288 2.841-.797 1.388-.801 2.381-2.095 2.795-3.643l.518-1.932-1.932-.518c-.749-.201-1.515-.252-2.263-.163 2.457-.751 4.25-3.038 4.25-5.738zm-49.724 15.688c-.077-.11-.156-.22-.231-.331-.375-.836-.47-1.762-.23-2.659.277-1.032.938-1.895 1.864-2.429 1.09 1.888.456 4.299-1.403 5.419zm-.511-7.409c-.523.906-1.364 1.554-2.367 1.841-.048-.134-.088-.27-.133-.405-.14-.898.01-1.809.47-2.607.534-.925 1.397-1.587 2.43-1.864.275 1.032.134 2.11-.4 3.035zm-3.675-4.288c-.013-.159-.031-.316-.041-.475.242-1.976 1.911-3.516 3.951-3.516 0 2.175-1.746 3.942-3.91 3.991zm.303-6.256c.031-.172.06-.345.095-.517.335-.806.907-1.484 1.676-1.927.926-.534 2.004-.675 3.035-.4-.563 2.099-2.704 3.351-4.806 2.844zm-.19 14.782c.056.128.118.253.177.38-.396-.092-.801-.144-1.209-.155.251-.034.502-.083.751-.15zm5.048-20.385c-1 .268-2.04.135-2.946-.36.073-.155.141-.311.217-.464 1.202-1.567 3.402-2.055 5.158-1.04-.534.925-1.397 1.587-2.429 1.864zm6.021-5.688c-1.49 1.489-4.064 1.503-5.586.057.108-.127.213-.257.323-.382.697-.54 1.538-.847 2.434-.847 1.069 0 2.074.416 2.829 1.172zm2.645-8.444c-.474 2.808-2.903 4.959-5.834 5 .474-2.808 2.903-4.959 5.834-5zm-9.716 1.373c1.559 1.56 1.559 4.097 0 5.657-.756-.756-1.172-1.76-1.172-2.828 0-1.069.416-2.074 1.172-2.829zm-1.414 7.07.226.227c-.085.117-.174.232-.258.35-.134-.448-.324-.867-.552-1.264.179.24.369.472.584.687zm-3.767-1.175c.926.534 1.587 1.396 1.864 2.429.276 1.032.134 2.11-.4 3.035-.926-.534-1.587-1.396-1.864-2.429-.277-1.032-.135-2.11.4-3.035zm.463 7.196.279.161c-.053.137-.105.274-.156.411-.265-.433-.588-.813-.943-1.159.258.213.525.417.82.587zm-3.943-.16c1.032.276 1.895.938 2.429 1.863s.676 2.003.399 3.036c-1.032-.277-1.895-.938-2.429-1.864s-.675-2.003-.399-3.035zm2.311 6.83.303.081c-.016.143-.026.286-.039.429-.334-.315-.703-.592-1.101-.825.271.119.544.237.837.315zm-3.851.866c2.206 0 4 1.794 4 4-2.206 0-4-1.794-4-4zm4 6h.312c.021.138.037.277.06.414-.367-.197-.748-.353-1.139-.468.252.032.507.054.767.054zm-3.495 1.833c1.031-.276 2.109-.134 3.035.399.925.534 1.587 1.396 1.863 2.429-1.03.278-2.109.135-3.035-.399-.925-.534-1.587-1.397-1.863-2.429zm2.515 7.436c1.911-1.105 4.358-.447 5.462 1.46 0 .001.001.002.001.003-1.913 1.104-4.361.445-5.463-1.463zm41.98 7.731v6h-6.78l1.2-6zm-19.538.208 3.538-6.192 3.538 6.192 5.144-1.715-.702 3.507h-6.98v2h6.58l-.4 2h-14.36l-.4-2h6.58v-2h-6.98l-.701-3.507zm-5.682 5.792h-6.78v-6h5.58zm-13.5 3-3.199-4h7.919v2.521l7.828 5.479h-15.747zm14.72 3.079-5.828-4.079h5.828zm21.828-4.079-5.828 4.079v-4.079zm12.091-3-3.199 4 3.199 4h-15.747l7.828-5.479v-2.521zm-2.84-15.407c.249.067.499.115.751.15-.408.011-.813.063-1.209.155.059-.127.12-.252.177-.38zm-2.243-17.301c.769.444 1.341 1.122 1.676 1.927.035.171.064.344.095.516-2.103.508-4.243-.744-4.806-2.844 1.032-.275 2.109-.134 3.035.401zm2.115 8.224c-.01.159-.028.317-.041.475-2.164-.049-3.91-1.816-3.91-3.991 2.04 0 3.709 1.54 3.951 3.516zm-1.685 3.592c.461.798.61 1.708.471 2.607-.045.135-.086.271-.133.405-1.003-.286-1.844-.935-2.367-1.841-.534-.925-.676-2.002-.399-3.035 1.03.277 1.893.939 2.428 1.864zm3.619-7.463c-.013-.143-.023-.286-.039-.429l.303-.081c.292-.078.565-.196.838-.315-.399.233-.768.509-1.102.825zm2.575-7.341c.276 1.032.135 2.11-.399 3.035s-1.396 1.587-2.429 1.864c-.276-1.032-.135-2.11.399-3.036.534-.925 1.397-1.586 2.429-1.863zm-4.067.732c-.051-.138-.103-.275-.156-.411l.279-.161c.295-.171.563-.374.82-.587-.355.346-.677.726-.943 1.159zm-1.277-5.339c.277-1.032.938-1.895 1.864-2.429.534.925.677 2.003.4 3.035s-.938 1.895-1.864 2.429c-.534-.925-.676-2.003-.4-3.035zm-1.32-1.941c-.227.397-.418.816-.552 1.264-.083-.118-.172-.233-.258-.35l.226-.226c.216-.216.406-.448.584-.688zm-1.997-6.383c.756.756 1.172 1.76 1.172 2.829 0 1.068-.416 2.072-1.172 2.828-1.559-1.56-1.559-4.098 0-5.657zm-9.716-1.373c2.931.04 5.36 2.192 5.834 4.999-2.931-.04-5.36-2.191-5.834-4.999zm2.645 8.443c.756-.755 1.761-1.171 2.829-1.171.896 0 1.737.307 2.434.847.11.125.215.255.323.382-1.522 1.446-4.097 1.432-5.586-.058zm8.751 4.865c.076.153.144.31.217.465-.905.493-1.945.627-2.947.359-1.032-.277-1.895-.938-2.429-1.864 1.754-1.013 3.956-.527 5.159 1.04zm-3.159 18.96c.926.535 1.587 1.397 1.864 2.43.24.897.145 1.823-.23 2.659-.075.112-.154.221-.231.331-1.859-1.121-2.492-3.532-1.403-5.42zm3.197 6.464c.001-.001.001-.002.001-.003 1.104-1.907 3.553-2.564 5.462-1.46-1.103 1.908-3.552 2.568-5.463 1.463zm7.978-8.899c-.276 1.033-.938 1.895-1.863 2.429s-2.003.675-3.035.399c.276-1.032.938-1.895 1.863-2.429.926-.533 2.004-.675 3.035-.399zm-3.867-1.419c.023-.137.039-.276.06-.414h.312c.259 0 .513-.022.763-.054-.39.116-.769.271-1.135.468zm.372-2.414c0-2.206 1.794-4 4-4 0 2.206-1.794 4-4 4z" />
    </svg>
  ),
  remove: ({ size, color, ...props }) => (
    <svg
      enableBackground="new 0 0 32 32"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      fill={color}
      {...props}
    >
      <path d="M20.377,16.519l6.567-6.566c0.962-0.963,0.962-2.539,0-3.502l-0.876-0.875c-0.963-0.964-2.539-0.964-3.501,0  L16,12.142L9.433,5.575c-0.962-0.963-2.538-0.963-3.501,0L5.056,6.45c-0.962,0.963-0.962,2.539,0,3.502l6.566,6.566l-6.566,6.567  c-0.962,0.963-0.962,2.538,0,3.501l0.876,0.876c0.963,0.963,2.539,0.963,3.501,0L16,20.896l6.567,6.566  c0.962,0.963,2.538,0.963,3.501,0l0.876-0.876c0.962-0.963,0.962-2.538,0-3.501L20.377,16.519z" />
    </svg>
  ),
  ava: ({ size, color, ...props }) => (
    <svg
      width={size}
      fill={color}
      id="Layer_1"
      version="1.1"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="none" height="50" width="50" />
      <circle
        cx="25"
        cy="24"
        fill="none"
        r="12"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <circle
        cx="25"
        cy="24"
        fill="none"
        r="8"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M47,10H37  c-1.469,0-2.484-4-4-4H17c-1.516,0-2.531,4-4,4H3c-1.104,0-2,0.896-2,2v27c0,1.104,0.896,2,2,2h44c1.104,0,2-0.896,2-2V12  C49,10.896,48.104,10,47,10z"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path d="M9,14c0,0-0.826,0-1,0c-1.104,0-2,0.896-2,2s0.896,2,2,2c0.174,0,0.826,0,1,0c1.104,0,2-0.896,2-2S10.104,14,9,14z" />
    </svg>
  ),
  tools: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      viewBox="0 0 48.5 79"
      {...props}
    >
      <g>
        <path
          fill={color}
          d="M46.7,11.8c0-3.9-1.8-7.4-4.7-9.7c-0.4-0.3-1,0-1,0.5V11l-6.2,3.8L28.5,11V2.7c0-0.5-0.6-0.8-1-0.5
		c-2.8,2.2-4.7,5.5-4.7,9.4c-0.1,5,2.9,9.3,7.2,11.2v33.9c-4.2,1.8-7.2,6-7.2,10.9c0,3.9,1.8,7.4,4.7,9.7c0.4,0.3,1,0,1-0.5v-8.3
		l6.2-3.8l6.2,3.8v8.3c0,0.5,0.6,0.8,1,0.5c2.8-2.2,4.7-5.5,4.7-9.4c0.1-5-2.9-9.3-7.2-11.2V22.6C43.7,20.8,46.7,16.7,46.7,11.8z"
        />
        <path
          fill={color}
          d="M15.5,36.8h-3.7V14.5l1.6-2.6l-2-9.9h-4l-2,9.9l1.6,2.6v22.3H3.3c-0.5,0-0.9,0.5-0.9,1v1.8
		c0,0.6,0.4,1,0.9,1h0.2c-0.7,1.2-1.1,2.7-1.1,4.3V70c0,4.2,3,7.7,6.7,7.7h0.5c3.7,0,6.7-3.4,6.7-7.7V44.9c0-1.6-0.4-3-1.1-4.3h0.2
		c0.5,0,0.9-0.5,0.9-1v-1.8C16.4,37.2,16,36.8,15.5,36.8z M5.7,72.5H4.2V44.9h1.5V72.5z M10.1,72.5H8.6V44.9h1.5V72.5z M14.4,72.5
		h-1.5V44.9h1.5V72.5z"
        />
      </g>
    </svg>
  ),
  view: ({ size, color, ...props }) => (
    <svg
      width={size}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icon-22-eye" fill={color}>
          <path
            d="M17,9 C8,9 4,16 4,16 C4,16 8,23.000001 17,23 C26,22.999999 30,16 30,16 C30,16 26,9 17,9 L17,9 Z M17,20 C19.2091391,20 21,18.2091391 21,16 C21,13.7908609 19.2091391,12 17,12 C14.7908609,12 13,13.7908609 13,16 C13,18.2091391 14.7908609,20 17,20 L17,20 Z M17,19 C18.6568543,19 20,17.6568543 20,16 C20,14.3431457 18.6568543,13 17,13 C15.3431457,13 14,14.3431457 14,16 C14,17.6568543 15.3431457,19 17,19 L17,19 Z M17,17 C17.5522848,17 18,16.5522848 18,16 C18,15.4477152 17.5522848,15 17,15 C16.4477152,15 16,15.4477152 16,16 C16,16.5522848 16.4477152,17 17,17 L17,17 Z"
            id="eye"
          />
        </g>
      </g>
    </svg>
  ),
  operation: ({ size, color }) => (
    <svg
      width={size}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 510.425 510.425"
    >
      {" "}
      <g>
        <g fill={color}>
          <path
            d="M397.525,319.1c-16.7-16.6-43.6-16.6-60.3,0c-6.9,6.9-11.2,15.9-12.3,25.5l-72.3-72.3c-27.8-27.9-65.9-43.1-105.3-42.2
			c1.1-6.6,2.7-13.1,4.8-19.4c1-2.9,0.2-6-1.9-8.2l-76.8-76.8c-3.1-3.1-8.2-3.1-11.3,0c-3.1,3.1-3.1,8.2,0,11.3l73.4,73.4
			c-2,6.9-3.5,13.9-4.5,21c-7.1,1-14.1,2.5-21,4.5l-73.4-73.4c-3.1-3.1-8.2-3.1-11.3,0c-3.1,3.1-3.1,8.2,0,11.3l76.8,76.8
			c2.1,2.1,5.3,2.9,8.2,1.9c6.3-2.1,12.8-3.7,19.4-4.8c-1,39.4,14.3,77.4,42.1,105.3l72.3,72.3c-23.4,2.6-40.3,23.7-37.7,47.1
			c1.1,9.6,5.4,18.6,12.3,25.5c16.7,16.7,43.7,16.7,60.4,0c14.5-14.5,16.6-37.2,5.1-54.2l10.8-10.8c3.1-3.1,3.1-8.2,0-11.3
			c-3.1-3.1-8.2-3.1-11.3,0l-10.3,10.2l-90.2-90.2c-25.4-25-39-59.7-37.5-95.4c35.7-1.4,70.4,12.1,95.6,37.4l90.2,90.2l-10.3,10.3
			c-3.1,3.2-3,8.2,0.2,11.3c3.1,3,8,3,11.1,0l10.8-10.8c19.5,13.2,46,8.2,59.3-11.3C414.125,356.3,412.025,333.6,397.525,319.1z
			 M275.425,467.8c0,14.7-11.9,26.6-26.6,26.6c-14.7,0-26.6-11.9-26.6-26.6c-0.1-14.7,11.8-26.6,26.6-26.6
			C263.525,441.2,275.425,453.1,275.425,467.8z M386.225,368.2c-10.4,10.4-27.3,10.4-37.7,0c-10.4-10.4-10.4-27.3,0-37.7
			c10.4-10.4,27.3-10.4,37.7,0C396.625,340.9,396.625,357.8,386.225,368.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M479.025,282.4l-161.6-161.7c-3.1-3.1-8.2-3.1-11.3,0l-2.4,2.4L182.925,2.3c-1.5-1.5-3.5-2.3-5.7-2.3
			c-2.1,0-4.2,0.8-5.7,2.3c-24.2,24.2-24.3,63.5,0,87.8l47.1,47.1c2.5,2.5,6.4,3.1,9.6,1.3c13.1-7.3,29.4-5.8,41,3.8l8.3,6.9
			l-0.9,0.9c-3.1,3.1-3.2,8.2,0,11.3l161.7,161.7c11.2,11.2,29.4,11.3,40.6,0.1l0.1-0.1C490.225,311.8,490.225,293.6,479.025,282.4z
			 M289.025,137.8l-9.5-7.9c-15-12.3-35.5-15.4-53.5-8.1l-43.1-43.1c-15.8-15.8-18-40.7-5.2-59l114.7,114.7L289.025,137.8z
			 M467.725,311.8c-5,5-13,5-18,0c0,0,0,0-0.1-0.1l-156-156l1.3-1.3c0.1-0.1,0.2-0.2,0.2-0.2l14.1-14.2l2.4-2.4l156,156
			C472.725,298.6,472.725,306.8,467.725,311.8z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  edit: ({ size, color, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      {...props}
    >
      <path
        className="a"
        d="M20.254,13.5H22.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-1-1H20.253a11.8,11.8,0,0,0-1-2.922L20.839,5.99a1,1,0,0,0,0-1.414L19.424,3.161a1,1,0,0,0-1.414,0L16.42,4.75a11.769,11.769,0,0,0-2.92-1V1.5a1,1,0,0,0-1-1h-1a1,1,0,0,0-1,1V3.748a11.777,11.777,0,0,0-2.921,1L5.989,3.161a1,1,0,0,0-1.414,0L3.16,4.576a1,1,0,0,0,0,1.414L4.75,7.579a11.821,11.821,0,0,0-1,2.921H1.5a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H3.746a11.821,11.821,0,0,0,1,2.921l-1.59,1.59a1,1,0,0,0,0,1.414l1.415,1.414a1,1,0,0,0,1.414,0l1.589-1.589A11.8,11.8,0,0,0,10.5,20.254V22.5a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V20.254a11.8,11.8,0,0,0,2.92-1l1.591,1.589a1,1,0,0,0,1.414,0l1.414-1.414a1,1,0,0,0,0-1.414l-1.589-1.59A11.821,11.821,0,0,0,20.254,13.5Z"
      />
      <circle className="a" cx="12" cy="12" r="4.5" />
    </svg>
  ),
  eye: ({ size, color, ...props }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      viewBox="0 0 511.626 511.626"
    >
      <g>
        <path
          fill={color}
          d="M505.918,236.117c-26.651-43.587-62.485-78.609-107.497-105.065c-45.015-26.457-92.549-39.687-142.608-39.687
		c-50.059,0-97.595,13.225-142.61,39.687C68.187,157.508,32.355,192.53,5.708,236.117C1.903,242.778,0,249.345,0,255.818
		c0,6.473,1.903,13.04,5.708,19.699c26.647,43.589,62.479,78.614,107.495,105.064c45.015,26.46,92.551,39.68,142.61,39.68
		c50.06,0,97.594-13.176,142.608-39.536c45.012-26.361,80.852-61.432,107.497-105.208c3.806-6.659,5.708-13.223,5.708-19.699
		C511.626,249.345,509.724,242.778,505.918,236.117z M194.568,158.03c17.034-17.034,37.447-25.554,61.242-25.554
		c3.805,0,7.043,1.336,9.709,3.999c2.662,2.664,4,5.901,4,9.707c0,3.809-1.338,7.044-3.994,9.704
		c-2.662,2.667-5.902,3.999-9.708,3.999c-16.368,0-30.362,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971
		c0,3.811-1.336,7.044-3.999,9.71c-2.667,2.668-5.901,3.999-9.707,3.999c-3.809,0-7.044-1.334-9.71-3.999
		c-2.667-2.666-3.999-5.903-3.999-9.71C169.015,195.482,177.535,175.065,194.568,158.03z M379.867,349.04
		c-38.164,23.12-79.514,34.687-124.054,34.687c-44.539,0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222
		c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.207-17.417,64.236c0,35.216,12.517,65.329,37.544,90.362
		s55.151,37.544,90.362,37.544c35.214,0,65.329-12.518,90.362-37.544s37.545-55.146,37.545-90.362
		c0-23.029-5.808-44.447-17.419-64.236c43.585,22.265,79.846,55.865,108.776,100.783C449.767,294.84,418.031,325.913,379.867,349.04
		z"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
};

// параметри width, height, fill(колір) видалені та будуть передаватися props-ами
